import { useLayoutEffect, useRef, useState } from 'react';

/*
 * Всё про показ экрана — в одном списке под одной кнопкой: показать окно
 * приложения или весь экран, остановить показ, передать или забрать право.
 * Список собран на контекстном меню чата (.ctx): те же пункты, тот же вид.
 * Ставится над кнопкой, которая его открыла.
 */
export type ScreenMenuItem = { label: string; onPick: () => void; danger?: boolean };

export function ScreenMenu({
  anchor,
  items,
  onClose,
}: {
  anchor: HTMLElement | null;
  items: ScreenMenuItem[];
  onClose: () => void;
}) {
  const [pos, setPos] = useState<{ left: number; bottom: number } | null>(null);
  const menuRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const r = anchor?.getBoundingClientRect();
    if (!r) return;
    // Меню держится в пределах экрана: у кнопки «Завершить» оно стоит у
    // правого края и раньше уезжало за границу на телефоне. Половина ширины
    // меню берётся по факту, а пока его нет — по минимальной (110).
    const half = (menuRef.current?.offsetWidth ?? 220) / 2;
    const edge = 10;
    const center = r.left + r.width / 2;
    const left = Math.min(Math.max(center, half + edge), window.innerWidth - half - edge);
    setPos({ left, bottom: window.innerHeight - r.top + 8 });
  }, [anchor]);

  return (
    <>
      <div className="ctx-back" onClick={onClose} />
      <div
        ref={menuRef}
        className="menu ctx call-screen-menu"
        role="menu"
        style={pos ? { left: pos.left, bottom: pos.bottom, top: 'auto' } : undefined}
      >
        {items.map((it) => (
          <button
            key={it.label}
            type="button"
            className={`menu-item${it.danger ? ' danger' : ''}`}
            onClick={() => {
              onClose();
              it.onPick();
            }}
          >
            {it.label}
          </button>
        ))}
      </div>
    </>
  );
}
